document.addEventListener('DOMContentLoaded', function () {

  const root = document.querySelector('.cg-caraway-pdp');

  if (!root) return;


  /* -----------------------------------
     MEDIA GALLERY
  ----------------------------------- */

  const thumbnails = root.querySelectorAll('.cg-thumbnail');
  const mediaSlides = root.querySelectorAll('.cg-media-slide');


  function changeMedia(mediaId) {

    if (!mediaId) return;

    mediaSlides.forEach(slide => {
      slide.classList.toggle(
        'is-active',
        slide.dataset.mediaId === String(mediaId)
      );
    });


    thumbnails.forEach(thumb => {
      thumb.classList.toggle(
        'is-active',
        thumb.dataset.targetMedia === String(mediaId)
      );
    });

  }


  thumbnails.forEach(thumb => {

    thumb.addEventListener('click', function () {
      changeMedia(this.dataset.targetMedia);
    });

  });



  /* -----------------------------------
     PRODUCT ELEMENTS
  ----------------------------------- */

  const variantInputs = root.querySelectorAll(
    '.cg-variant-card input[type="radio"]'
  );

  const price = root.querySelector('[data-current-price]');
  const comparePrice = root.querySelector('[data-compare-price]');
  const saveBadge = root.querySelector('[data-save-badge]');
  const selectedVariant = root.querySelector('[data-selected-variant]');

  const atcPrice = root.querySelector('[data-atc-price]');
  const stickyPrice = root.querySelector('[data-sticky-price]');



  /* -----------------------------------
     QUANTITY
  ----------------------------------- */

  const quantityInput = root.querySelector('[data-quantity]');
  const minus = root.querySelector('[data-qty-minus]');
  const plus = root.querySelector('[data-qty-plus]');



  /* -----------------------------------
     BUNDLE & SAVE
  ----------------------------------- */

  const bundleCards = root.querySelectorAll(
    '[data-bundle-card]'
  );

  const bundleInputs = root.querySelectorAll(
    'input[name="cg_bundle"]'
  );

  const bundlePrices = root.querySelectorAll(
    '[data-bundle-price]'
  );

  const bundleOriginalPrices = root.querySelectorAll(
    '[data-bundle-original]'
  );



  /* -----------------------------------
     EXACT BUNDLE DISCOUNTS

     BUY 1 = 7%
     BUY 2 = 12%
     BUY 3 = 20%
  ----------------------------------- */

  function getBundleDiscount(quantity) {

    quantity = Number(quantity || 1);

    if (quantity === 1) {
      return 7;
    }

    if (quantity === 2) {
      return 12;
    }

    if (quantity === 3) {
      return 20;
    }

    return 0;

  }



  /* -----------------------------------
     MONEY HELPERS
  ----------------------------------- */

  function formatBundleMoney(cents) {

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);

  }


  function moneyTextToCents(text) {

    if (!text) return 0;

    const clean = text
      .replace(/,/g, '')
      .replace(/[^\d.]/g, '');

    const value = parseFloat(clean);

    if (isNaN(value)) return 0;

    return Math.round(value * 100);

  }



  /* -----------------------------------
     CURRENT VARIANT PRICE
  ----------------------------------- */

  function getCurrentVariantPrice() {

    const checkedVariant = root.querySelector(
      '.cg-variant-card input[type="radio"]:checked'
    );


    if (checkedVariant) {

      return Number(
        checkedVariant.dataset.priceCents || 0
      );

    }


    /*
      Fallback for products with
      only one variant.
    */

    if (price) {

      return moneyTextToCents(
        price.textContent
      );

    }


    return 0;

  }



  /* -----------------------------------
     CURRENT BUNDLE
  ----------------------------------- */

  function getSelectedBundle() {

    return root.querySelector(
      'input[name="cg_bundle"]:checked'
    );

  }



  /* -----------------------------------
     MAKE BUNDLE LABELS MATCH
     7% / 12% / 20%
  ----------------------------------- */

  function updateBundleLabels() {

    bundleCards.forEach(card => {

      const input = card.querySelector(
        'input[name="cg_bundle"]'
      );

      if (!input) return;


      const quantity = Number(
        input.dataset.bundleQuantity ||
        input.value ||
        1
      );


      const discount =
        getBundleDiscount(quantity);


      /*
        Keep datasets synced too.
      */

      input.dataset.bundleDiscount =
        String(discount);


      const priceElement =
        card.querySelector(
          '[data-bundle-price]'
        );


      if (priceElement) {

        priceElement.dataset.bundleDiscountValue =
          String(discount);

      }


      /*
        Update subtitle.
      */

      const subtitle =
        card.querySelector(
          '.cg-bundle-subtitle'
        );


      if (subtitle) {

        subtitle.textContent =
          'You save ' +
          discount +
          '%';

      }


      /*
        Update or create SAVE badge.
      */

      let titleRow =
        card.querySelector(
          '.cg-bundle-title-row'
        );


      const title =
        card.querySelector(
          '.cg-bundle-title'
        );


      /*
        First bundle may not currently
        have a title row.
      */

      if (!titleRow && title) {

        titleRow =
          document.createElement('div');

        titleRow.className =
          'cg-bundle-title-row';


        title.parentNode.insertBefore(
          titleRow,
          title
        );


        titleRow.appendChild(
          title
        );

      }


      let saveLabel =
        card.querySelector(
          '.cg-bundle-save'
        );


      if (!saveLabel && titleRow) {

        saveLabel =
          document.createElement('span');

        saveLabel.className =
          'cg-bundle-save';

        titleRow.appendChild(
          saveLabel
        );

      }


      if (saveLabel) {

        saveLabel.textContent =
          'SAVE ' +
          discount +
          '%';

      }


      /*
        Make sure every bundle,
        including BUY 1,
        has an original price.
      */

      const priceArea =
        card.querySelector(
          '.cg-bundle-price-area'
        );


      let originalPrice =
        card.querySelector(
          '[data-bundle-original]'
        );


      if (
        !originalPrice &&
        priceArea
      ) {

        originalPrice =
          document.createElement('span');

        originalPrice.className =
          'cg-bundle-original';

        originalPrice.setAttribute(
          'data-bundle-original',
          ''
        );

        originalPrice.dataset.bundleQty =
          String(quantity);


        priceArea.appendChild(
          originalPrice
        );

      }

    });

  }



  /* -----------------------------------
     CALCULATE BUNDLE PRICE
  ----------------------------------- */

  function calculateBundleTotal(
    unitPrice,
    quantity
  ) {

    quantity = Number(
      quantity || 1
    );


    const discount =
      getBundleDiscount(
        quantity
      );


    const normalTotal =
      unitPrice * quantity;


    const discountedTotal =
      Math.round(
        normalTotal *
        (
          1 -
          discount / 100
        )
      );


    return {
      quantity: quantity,
      discount: discount,
      normalTotal: normalTotal,
      discountedTotal: discountedTotal
    };

  }



  /* -----------------------------------
     SELECTED PURCHASE TOTAL
  ----------------------------------- */

  function getSelectedPurchaseTotal(
    unitPrice
  ) {

    if (!unitPrice) {
      return 0;
    }


    const quantity =
      quantityInput
        ? Math.max(
            1,
            Number(
              quantityInput.value || 1
            )
          )
        : 1;


    /*
      Only quantities 1, 2 and 3
      use our bundle discount.
    */

    const result =
      calculateBundleTotal(
        unitPrice,
        quantity
      );


    return result.discountedTotal;

  }



  /* -----------------------------------
     UPDATE ADD TO CART BUTTON PRICE
  ----------------------------------- */

  function updatePurchaseButtonPrice(
    unitPrice
  ) {

    if (!unitPrice) {

      unitPrice =
        getCurrentVariantPrice();

    }


    if (!unitPrice) return;


    const total =
      getSelectedPurchaseTotal(
        unitPrice
      );


    if (atcPrice) {

      atcPrice.textContent =
        formatBundleMoney(
          total
        );

    }


    if (stickyPrice) {

      stickyPrice.textContent =
        formatBundleMoney(
          total
        );

    }

  }



  /* -----------------------------------
     UPDATE ALL BUNDLE PRICES
  ----------------------------------- */

  function updateBundlePrices(
    unitPrice
  ) {

    if (!unitPrice) {

      unitPrice =
        getCurrentVariantPrice();

    }


    if (!unitPrice) return;


    /*
      Discounted bundle prices.
    */

    bundlePrices.forEach(item => {

      const quantity = Number(
        item.dataset.bundleQty || 1
      );


      const result =
        calculateBundleTotal(
          unitPrice,
          quantity
        );


      item.textContent =
        formatBundleMoney(
          result.discountedTotal
        );

    });


    /*
      Original crossed-out prices.
    */

    root
      .querySelectorAll(
        '[data-bundle-original]'
      )
      .forEach(item => {

        const quantity = Number(
          item.dataset.bundleQty || 1
        );


        const normalTotal =
          unitPrice * quantity;


        item.textContent =
          formatBundleMoney(
            normalTotal
          );

      });


    /*
      Update Add to Cart and sticky price
      based on currently selected bundle.
    */

    updatePurchaseButtonPrice(
      unitPrice
    );

  }



  /* -----------------------------------
     SELECT BUNDLE
  ----------------------------------- */

  function selectBundle(input) {

    if (!input) return;


    bundleCards.forEach(card => {

      card.classList.remove(
        'is-selected'
      );

    });


    const card =
      input.closest(
        '[data-bundle-card]'
      );


    if (card) {

      card.classList.add(
        'is-selected'
      );

    }


    input.checked = true;


    const quantity = Number(
      input.dataset.bundleQuantity ||
      input.value ||
      1
    );


    if (quantityInput) {

      quantityInput.value =
        quantity;

    }


    /*
      Update Add to Cart button
      immediately.
    */

    updatePurchaseButtonPrice(
      getCurrentVariantPrice()
    );

  }



  /* -----------------------------------
     SYNC BUNDLE WITH QUANTITY
  ----------------------------------- */

  function syncBundleWithQuantity() {

    if (!quantityInput) return;


    const quantity = Math.max(
      1,
      Number(
        quantityInput.value || 1
      )
    );


    let matchFound = false;


    bundleInputs.forEach(input => {

      const bundleQuantity = Number(
        input.dataset.bundleQuantity ||
        input.value ||
        1
      );


      const card =
        input.closest(
          '[data-bundle-card]'
        );


      if (
        bundleQuantity === quantity
      ) {

        input.checked = true;

        matchFound = true;


        if (card) {

          card.classList.add(
            'is-selected'
          );

        }

      } else {

        input.checked = false;


        if (card) {

          card.classList.remove(
            'is-selected'
          );

        }

      }

    });


    /*
      Quantity above 3:
      no bundle discount.
    */

    if (!matchFound) {

      bundleCards.forEach(card => {

        card.classList.remove(
          'is-selected'
        );

      });

    }


    updatePurchaseButtonPrice(
      getCurrentVariantPrice()
    );

  }



  /* -----------------------------------
     INITIALIZE BUNDLE LABELS
  ----------------------------------- */

  updateBundleLabels();



  /* -----------------------------------
     BUNDLE CLICK EVENTS
  ----------------------------------- */

  bundleInputs.forEach(input => {

    input.addEventListener(
      'change',
      function () {

        selectBundle(this);

      }
    );

  });



  /* -----------------------------------
     VARIANTS
  ----------------------------------- */

  variantInputs.forEach(input => {

    input.addEventListener(
      'change',
      function () {


        root
          .querySelectorAll(
            '.cg-variant-card'
          )
          .forEach(card => {

            card.classList.remove(
              'is-selected'
            );

          });


        this
          .closest(
            '.cg-variant-card'
          )
          .classList.add(
            'is-selected'
          );


        if (selectedVariant) {

          selectedVariant.textContent =
            this.dataset.title;

        }


        /*
          Main product price remains
          selected variant's normal
          single-item price.
        */

        if (price) {

          price.textContent =
            this.dataset.price;

        }


        const compare = Number(
          this.dataset.compareCents || 0
        );


        const current = Number(
          this.dataset.priceCents || 0
        );


        /*
          Main Shopify compare price.
        */

        if (
          comparePrice &&
          saveBadge &&
          compare > current
        ) {

          comparePrice.style.display =
            '';

          comparePrice.textContent =
            this.dataset.compare;


          const percent =
            Math.round(
              (
                (
                  compare -
                  current
                ) /
                compare
              ) *
              100
            );


          saveBadge.style.display =
            '';

          saveBadge.textContent =
            'SAVE ' +
            percent +
            '%';

        } else {


          if (comparePrice) {

            comparePrice.style.display =
              'none';

          }


          if (saveBadge) {

            saveBadge.style.display =
              'none';

          }

        }


        /*
          Recalculate:
          BUY 1 = 7%
          BUY 2 = 12%
          BUY 3 = 20%
        */

        updateBundlePrices(
          current
        );


        /*
          Variant image.
        */

        if (this.dataset.media) {

          changeMedia(
            this.dataset.media
          );

        }


        /*
          Variant URL.
        */

        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          this.value
        );


        window.history.replaceState(
          {},
          '',
          url.toString()
        );

      }
    );

  });



  /* -----------------------------------
     QUANTITY MINUS
  ----------------------------------- */

  if (
    minus &&
    quantityInput
  ) {

    minus.addEventListener(
      'click',
      function () {

        quantityInput.value =
          Math.max(
            1,
            Number(
              quantityInput.value || 1
            ) - 1
          );


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     QUANTITY PLUS
  ----------------------------------- */

  if (
    plus &&
    quantityInput
  ) {

    plus.addEventListener(
      'click',
      function () {

        quantityInput.value =
          Number(
            quantityInput.value || 1
          ) + 1;


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     MANUAL QUANTITY CHANGE
  ----------------------------------- */

  if (quantityInput) {

    quantityInput.addEventListener(
      'change',
      function () {

        let quantity =
          Number(
            this.value || 1
          );


        if (quantity < 1) {

          quantity = 1;

        }


        this.value =
          quantity;


        syncBundleWithQuantity();

      }
    );

  }



  /* -----------------------------------
     INITIAL BUNDLE PRICES
  ----------------------------------- */

  updateBundlePrices(
    getCurrentVariantPrice()
  );



  /* -----------------------------------
     STICKY BUY BAR
  ----------------------------------- */

  const buybar =
    root.querySelector(
      '[data-buybar]'
    );

  const mainButton =
    root.querySelector(
      '.cg-add-to-cart'
    );

  const stickyButton =
    root.querySelector(
      '[data-sticky-add]'
    );


  function updateStickyBar() {

    if (
      !buybar ||
      !mainButton
    ) return;


    const buttonBox =
      mainButton
        .getBoundingClientRect();


    if (
      buttonBox.bottom < 0
    ) {

      buybar.classList.add(
        'is-visible'
      );

    } else {

      buybar.classList.remove(
        'is-visible'
      );

    }

  }


  window.addEventListener(
    'scroll',
    updateStickyBar,
    {
      passive: true
    }
  );


  updateStickyBar();



  /* -----------------------------------
     STICKY BUTTON
  ----------------------------------- */

  if (
    stickyButton &&
    mainButton
  ) {

    stickyButton.addEventListener(
      'click',
      function () {

        mainButton.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

      }
    );

  }

});